import AppConfig from '../config/appConfig';
import AjaxUtils from '../utils/AjaxUtils';
import LoggerUtils from '../utils/LoggerUtils';

const createFeedbackURL = AppConfig.server.mailFeedbackEndpoint + '/provideFeedback';

function createFeedback(config) {
  LoggerUtils.debug('REQUEST: Creating feedback');

  fetch(`${createFeedbackURL}`, {
    method: 'post',
    headers: AjaxUtils.getHeaders(),
    body: JSON.stringify(config.data)
  }).then(AjaxUtils.checkResponseStatus)
    .then(config.onSuccess)
    .catch(error => config.onError(error));
}

export default {
  createFeedback,
}